"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reclaimPricingCalculator = void 0;
const consts_1 = require("../consts");
const reclaimPricingCalculator = (seats, period) => {
    if (typeof seats !== "number" || seats < 1)
        throw new RangeError(`seats must be a number, 1 or greater (received ${seats})`);
    if (period !== "annually" && period !== "monthly")
        throw new Error(`period must be either "monthly" or "annually" (received "${period}")`);
    const lowerBoundIndex = consts_1.LOWER_BOUNDS.findIndex((min, i) => consts_1.LOWER_BOUNDS[i + 1] > seats || !consts_1.LOWER_BOUNDS[i + 1]);
    const lowerBound = consts_1.LOWER_BOUNDS[lowerBoundIndex];
    const upperBound = consts_1.LOWER_BOUNDS[lowerBoundIndex + 1]
        ? consts_1.LOWER_BOUNDS[lowerBoundIndex + 1] - 1
        : Infinity;
    const seatsInRange = seats - (lowerBound - 1);
    const { pro: proRangePrice, team: teamRangePrice } = consts_1.BREAKPOINTS[lowerBound][period];
    let proPrice = proRangePrice * seatsInRange;
    let teamPrice = teamRangePrice * seatsInRange;
    for (let i = 0; i < lowerBoundIndex; i++) {
        const lowerBoundForRange = consts_1.LOWER_BOUNDS[i];
        const upperBoundForRange = consts_1.LOWER_BOUNDS[i + 1];
        const breakpointForRange = consts_1.BREAKPOINTS[lowerBoundForRange][period];
        proPrice +=
            (upperBoundForRange - lowerBoundForRange) * breakpointForRange.pro;
        teamPrice +=
            (upperBoundForRange - lowerBoundForRange) * breakpointForRange.team;
    }
    const discount = period === "annually" ? consts_1.ADDITIONAL_ANNUAL_DISCOUNT : 0;
    const proPricePerUser = proPrice / seats;
    const teamPricePerUser = teamPrice / seats;
    const proPricePerUserDiscountedAmount = proPricePerUser * discount;
    const teamPricePerUserDiscountedAmount = teamPricePerUser * discount;
    const proPriceDiscountedAmount = proPrice * discount;
    const teamPriceDiscountedAmount = teamPrice * discount;
    const proPricePerUserWithDiscount = proPricePerUser - proPricePerUserDiscountedAmount;
    const teamPricePerUserWithDiscount = teamPricePerUser - teamPricePerUserDiscountedAmount;
    const proPriceWithDiscount = proPrice - proPriceDiscountedAmount;
    const teamPriceWithDiscount = teamPrice - teamPriceDiscountedAmount;
    return {
        proPricePerUser,
        teamPricePerUser,
        proPrice,
        teamPrice,
        proPricePerUserDiscountedAmount,
        teamPricePerUserDiscountedAmount,
        proPriceDiscountedAmount,
        teamPriceDiscountedAmount,
        proPricePerUserWithDiscount,
        teamPricePerUserWithDiscount,
        proPriceWithDiscount,
        teamPriceWithDiscount,
        lowerBound,
        upperBound,
        seatsInRange,
        discount,
    };
};
exports.reclaimPricingCalculator = reclaimPricingCalculator;
